import React from 'react'

export default function Box({className,children}) {
  return (
    <div className={`bg-white  rounded-md w-full shadow-md p-3 ${className}`}>
        {children}
    </div>
  )
}
